import { cn } from '@dashboard/ui'

interface ColorSwatchProps {
  color: string
  size?: 'sm' | 'md'
}

export const ColorSwatch = ({ color, size = 'md' }: ColorSwatchProps) => {
  return (
    <div
      className={cn(
        'shrink-0 border border-[#00000033]',
        size === 'sm' && 'size-5 rounded',
        size === 'md' && 'size-6 rounded-md',
      )}
      style={{ backgroundColor: color }}
    />
  )
}
